import CrewDeductions from '../../Crewing/CrewFormTabs/CrewDeductions'
export default CrewDeductions
